import { useEffect } from 'react';

const useSessionCheck = () => {
  let inactivityTimer;

  useEffect(() => {
    const checkSession = () => {
      //call the session-check endpoint to see if the user is still logged in
      fetch('/session-check')
        .then((response) => {
          if (response.status === 401) {
            window.location.href = '/login'; // Redirect to login
          }
        })
        .catch((err) => {
          console.error('Error checking session:', err);
        });
    };

    // Function to reset inactivity timer
    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimer);

      // Restart the inactivity timer
      inactivityTimer = setTimeout(() => {
        checkSession(); // Initial check once user becomes inactive
        const interval = setInterval(checkSession, 5000); // Check every 5s after inactivity
        return () => clearInterval(interval); // Cleanup on component unmount
      }, (60 * 60 + 5) * 1000); // Wait for 1 hour of inactivity, the extra 5 seds is to make sure the user is logged out after 1 hour of inactivity
    };

    // Add event listeners to detect user activity
    window.addEventListener('mousemove', resetInactivityTimer);
    window.addEventListener('keydown', resetInactivityTimer);
    window.addEventListener('scroll', resetInactivityTimer);
    window.addEventListener('click', resetInactivityTimer);

    // Start inactivity timer initially
    resetInactivityTimer();

    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener('mousemove', resetInactivityTimer);
      window.removeEventListener('keydown', resetInactivityTimer);
      window.removeEventListener('scroll', resetInactivityTimer);
      window.removeEventListener('click', resetInactivityTimer);
    };
  }, []);

  return null; // This hook doesn't return a UI component
};

export default useSessionCheck;
